import React, { FC, ReactNode } from 'react';
import styles from './upload.module.scss';
import { Col, Row, Upload } from 'antd';
import type { UploadProps } from 'antd';
import clsx from 'clsx';

interface UploadComponentProps extends UploadProps {
  name: string;
  label?: ReactNode;
  labelClass?: string;
  wrapperClass?: string;
  contentClass?: string;
}

const UploadComponent: FC<UploadComponentProps> = ({
  label,
  name,
  wrapperClass,
  labelClass,
  children,
  contentClass,
  ...remainingProps
}) => {
  return (
    <div
      className={clsx(styles.uploadWrapper, {
        [wrapperClass ?? '']: !!wrapperClass,
      })}>
      {label && (
        <label htmlFor={name} className={labelClass ?? ''}>
          {label}
        </label>
      )}
      <Upload {...remainingProps}>
        <Row className={contentClass}>
          <Col span={24}>{children}</Col>
        </Row>
      </Upload>
    </div>
  );
};

export default UploadComponent;
